"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaYupConfiguracoes = exports.yupConfiguracoes = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupConfiguracoes = yup.object({
    ano_site: yup.number().required().default(new Date().getFullYear()).label('Ano letivo nos Módulos Online'),
    armazena_aula_dada: yup.boolean().required().default(false).label('Armazenar o cálculo no campo aulas dadas'),
    armazena_aula_prev: yup.boolean().required().default(false).label('Armazenar o cálculo no campo aulas previstas'),
    autentique_apikey: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Token de acesso à API da Autentique'),
    autentique_email: yup
        .string()
        .email()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Email da conta da Autentique'),
    // TODO: Só tem no aluno online
    aviso_entrega_documentos: yup
        .boolean()
        .required()
        .default(false)
        .label('Avisar responsáveis sobre documentos pendentes'),
    // TODO: Deve ser feito nas publicações
    avisos_aprovacao: yup.boolean().notRequired().nullable().default(undefined).label('Avisos necessitam de aprovação'),
    // TODO: Discutir se isso é viável ainda usando as publicações
    avisos_nao_lidos: yup
        .boolean()
        .required()
        .default(false)
        .label('Apresentar os Avisos não lidos para os alunos e responsáveis'),
    biblioteca_url: yup.string().url().notRequired().nullable().default(undefined).label('URL da Biblioteca Online'),
    bim_site: yup.number().oneOf([1, 2, 3, 4]).required().default(1).label('Etapa nos Módulos Online'),
    blockfreqcont: yup.boolean().required().default(false).label('Para o Ensino Fundamental do 6ª a 9ª Ano e Médio'),
    blockfreqcontinf: yup
        .boolean()
        .required()
        .default(false)
        .label('Para o Ensino Infantil e Fundamental do 1ª ao 5ª Ano'),
    bloq_altera_senha: yup.boolean().required().default(false).label('Bloquear Alteração de senha do aluno'),
    bloq_debit: yup.boolean().required().default(false).label('Bloquear Alunos / Responsáveis em Débito'),
    bloq_debit_perfil: yup.boolean().required().default(false).label('Perfil do aluno'),
    bloq_debit_avisos: yup.boolean().required().default(false).label('Aviso'),
    bloq_debit_biblioteca: yup.boolean().required().default(false).label('Biblioteca'),
    bloq_debit_boletim: yup.boolean().required().default(false).label('Boletim'),
    bloq_debit_carencia: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Dias de carência para Bloquear Alunos / Responsáveis em Débito'),
    bloq_debit_catraca: yup.boolean().required().default(false).label('Catraca'),
    bloq_debit_conteudo: yup.boolean().required().default(false).label('Conteúdo Ministrado'),
    bloq_debit_documentos: yup.boolean().required().default(false).label('Documentos'),
    bloq_debit_docnentre: yup.boolean().required().default(false).label('Entrega de documentos'),
    bloq_debit_fichasaude: yup.boolean().required().default(false).label('Ficha de Saúde'),
    bloq_debit_financeiro: yup.boolean().required().default(false).label('Financeiro'),
    bloq_debit_horarios: yup.boolean().required().default(false).label('Horários de Aulas'),
    bloq_debit_materiais: yup.boolean().required().default(false).label('Materiais'),
    bloq_debit_mensagens: yup.boolean().required().default(false).label('Publicações'),
    bloq_debit_ocorrencias: yup.boolean().required().default(false).label('Ocorrências'),
    bloq_debit_provas: yup.boolean().required().default(false).label('Provas'),
    bloq_debit_rematricula: yup.boolean().required().default(false).label('Rematrícula'),
    bloq_debit_autorizacao_transporte: yup.boolean().required().default(false).label('Pessoas autorizadas'),
    bloq_debit_resp: yup
        .boolean()
        .required()
        .default(false)
        .label('Não permitir que responsáveis em débitos acessem o Módulo'),
    bloq_padrao_ocorre: yup.boolean().required().default(true).label('Bloquear texto padrão das ocorrências'),
    bloquear_digitacao_feriados: yup
        .boolean()
        .required()
        .default(false)
        .label('Bloquear Digitação de Presenças e Conteúdos nos feriados e fins de semana'),
    bloqueia_aluno_transferido: yup
        .boolean()
        .required()
        .default(false)
        .label('Bloquear Alunos inativos e seus Responsáveis'),
    boletim_rec_bim: yup
        .boolean()
        .required()
        .default(false)
        .label('Bloquear Boletim online para alunos em recuperação bimestral'),
    boletim_rec_bim_msg: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('boletim_rec_bim', {
        is: true,
        then: yup.string().required(),
    })
        .label('Mensagem para boletins bloqueados para alunos em recuperação bimestral'),
    boletim_rec_final: yup
        .boolean()
        .required()
        .default(false)
        .label('Bloquear Boletim para alunos que ficarem em recuperação final ou Exame Final'),
    boletim_rec_final_msg: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('boletim_rec_final', {
        is: true,
        then: yup.string().required(),
    })
        .label('Mensagem para boletins bloqueados para alunos em recuperação ou exame final'),
    boletim_reprovado: yup.boolean().required().default(false).label('Bloquear Boletim online para alunos reprovados'),
    boletim_reprovado_msg: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('boletim_reprovado', {
        is: true,
        then: yup.string().required(),
    })
        .label('Mensagem para boletins bloqueados para alunos reprovados'),
    boleto_futuros: yup.number().notRequired().nullable().default(undefined).label('Apresentar boletos até os próximos'),
    boleto_online: yup.boolean().required().default(false).label('Liberar a impressão de boletos'),
    boleto_passados: yup.number().notRequired().nullable().default(undefined).label('Apresentar boletos do ano de'),
    boletos_abertos: yup.boolean().required().default(false).label('Somente Boletos em Aberto'),
    chave_positivo: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Chave de integração com o Portal Positivo'),
    /** @deprecated No educador o conteúdo é por aula */
    conteudo_por_aula: yup.boolean().required().default(false).label('Validar conteúdo ministrado por aula'),
    dias_atraso_boleto: yup.number().notRequired().nullable().default(null).label('Dias de atraso para boleto'),
    dig_ef_fim: yup
        .date()
        .notRequired()
        .when('dig_ef_ini', (dig_ef_ini, schema) => {
        if (dig_ef_ini) {
            return schema.min(dig_ef_ini);
        }
        return schema;
    })
        .nullable()
        .default(undefined)
        .label('Fim da digitação da rec. / exame final'),
    dig_ef_ini: yup.date().notRequired().nullable().default(undefined).label('Início da digitação da rec. / exame final'),
    digi_aulad: yup.boolean().required().default(false).label('Liberar digitação de aulas dadas'),
    digi_aulap: yup.boolean().required().default(false).label('Liberar digitar aulas previstas'),
    digi_fim: yup
        .date()
        .required()
        .when('digi_ini', (digi_ini, schema) => {
        if (digi_ini) {
            return schema.min(digi_ini);
        }
        return schema;
    })
        .default(new Date(new Date().getFullYear(), 11, 31, 23, 59, 59))
        .label('Fim da digitação'),
    digi_ini: yup.date().required().default(new Date(new Date().getFullYear(), 0, 1)).label('Inicio da digitação'),
    digi_lib: yup.boolean().required().default(false).label('Liberar acesso aos professores'),
    email_entrega_documentos: yup
        .string()
        .email()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('E-mail para Entrega de Documentos'),
    esconder_colunasoma: yup
        .boolean()
        .required()
        .default(false)
        .label('Esconder a coluna soma na tela de digitação e relatório de notas'),
    esconder_financeiro: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Esconder financeiro para responsáveis com mais de'),
    falta_dia: yup
        .boolean()
        .required()
        .default(false)
        .label('Controlar a frequência por faltas diárias no Ensino Infantil e Fundamental de 1ª a 5ª série'),
    fin_bol_auto: yup.boolean().required().default(false).label('Fazer o envio de boletos automaticamente'),
    fin_bol_auto_apos_venc: yup.number().notRequired().nullable().default(undefined).label('Enviar após o vencimento em'),
    fin_bol_auto_dias: yup.number().notRequired().nullable().default(undefined).label('Enviar antes do vencimento em'),
    fin_bol_auto_no_dia: yup.boolean().required().default(false).label('Enviar no dia do vencimento'),
    financeiro_ano_atual: yup.boolean().required().default(false).label('Não apresentar parcelas do próximo ano letivo'),
    gerar_aula_obs: yup.boolean().required().default(false).label('Gerar aulas com base nas observações de dia sem aula'),
    gerar_aula_pres: yup.boolean().required().default(false).label('Gerar aulas com base no registro de presenças'),
    habilita_anuncio_app: yup
        .boolean()
        .required()
        .default(false)
        .label('Liberar anúncio de download do App na tela de login'),
    habilita_app: yup.boolean().required().default(false).label('Liberar o Uso da App do Aluno / Responsável'),
    lib_aluno_debit: yup.boolean().required().default(false).label('Liberar Alunos mesmo com Responsável em Débito'),
    /** @deprecated Não será usando nas publicações */
    lib_mat_prof: yup.boolean().required().default(false).label('Habilitar o envio de Materiais para Professores'),
    liberar_questionarios: yup.boolean().required().default(false).label('Liberar Questionários'),
    // TODO: Foi feito isso no educador?
    liga_conteudo_monitor: yup
        .boolean()
        .required()
        .default(false)
        .label('Vincular conteúdo ministrado ao monitor de entrega de notas'),
    // TODO: Discutir como fica isso se já tem a logo na escola
    link_logo: yup.string().notRequired().nullable().default(undefined).label('Link do logo da escola'),
    login_aluno_codigo: yup.boolean().required().default(false).label('Usar o Código do aluno como login'),
    login_aluno_nasc: yup.boolean().required().default(false).label('Usar a Data de nascimento como senha do aluno'),
    login_resp_nasc: yup.boolean().required().default(false).label('Usar a Data de nascimento como senha do responsável'),
    login_responsavel_codigo: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(false)
        .label('Usar o Código do responsável como login'),
    login_responsavel_cpf: yup
        .boolean()
        .notRequired()
        .nullable()
        .default(false)
        .label('Usar o CPF do responsável como login'),
    marca_login_padrao: yup
        .mixed()
        .oneOf([...Object.values(enums_1.EMarcaLoginPadrao), undefined])
        .default(undefined)
        .label('Defina o tipo de login que aparecerá marcado'),
    mgs_bloqueio_boletins: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Apresentar mensagem quando o boletim for bloqueado usando a guia Bloquear Boletins'),
    mostrar_coluna_nota: yup
        .boolean()
        .required()
        .default(false)
        .label('Mostrar a coluna Média na tela de digitação de notas'),
    mostrar_coluna_ma: yup
        .boolean()
        .required()
        .default(false)
        .label('Mostrar a coluna Média Anual na tela de digitação de notas'),
    msg_atraso_boleto: yup.string().notRequired().nullable().default(undefined).label('Mensagem de atraso boleto'),
    n_apresentar_ma_rel: yup
        .boolean()
        .required()
        .default(false)
        .label('Não mostrar a coluna média anual no relatório de notas'),
    n_apresentar_nota_rel: yup
        .boolean()
        .required()
        .default(false)
        .label('Não mostrar a coluna nota no relatório de notas'),
    n_faltas_mat_principal: yup
        .boolean()
        .required()
        .default(false)
        .label('Não mostrar o total de faltas na matéria principal'),
    // TODO: Como ficou isso no educador?
    n_valida_periodo_conteudo: yup
        .boolean()
        .required()
        .default(false)
        .label('Não validar o período do bimestre no cadastro de Conteúdo Ministrado'),
    // TODO: Discutir isso
    obriga_conteudo: yup
        .boolean()
        .required()
        .default(false)
        .label('Obrigar o professor a lançar conteúdo ministrado ao registrar a frequência'),
    // TODO: Disctir isso
    ocorrencias_nao_lidas: yup
        .boolean()
        .required()
        .default(false)
        .label('Apresentar as Ocorrências não lidas para os responsáveis'),
    // TODO: Não esta claro onde isso
    ocorrencias_ordem_desc: yup
        .boolean()
        .required()
        .default(false)
        .label('Ordernar as ocorrências por data e hora descrescente'),
    pag_ini_a: yup
        .mixed()
        .oneOf(Object.values(enums_1.EPaginaInicialOnlineAluno))
        .required()
        .default(enums_1.EPaginaInicialOnlineAluno.Avisos)
        .label('Página Inicial para alunos'),
    pag_ini_r: yup
        .mixed()
        .oneOf(Object.values(enums_1.EPaginaInicialOnlineResponsavel))
        .required()
        .default(enums_1.EPaginaInicialOnlineResponsavel.Avisos)
        .label('Página Inicial para responsáveis'),
    prioriza_falta: yup.boolean().required().default(false).label('Priorizar as faltas dentro do dia de aula'),
    relat_ocorrencia_categoria: yup
        .boolean()
        .required()
        .default(false)
        .label('Liberar link de registro de conselho de classe'),
    remove_bim_atu_boletim: yup
        .boolean()
        .required()
        .default(false)
        .label('Remover texto do bimestre atual no cabeçalho do boletim'),
    site2viatu: yup.boolean().required().default(false).label('2ª Via Boleto Atualizado'),
    site_lib: yup.boolean().required().default(false).label('Aluno Online Liberado no Site'),
    sitemdesc: yup.boolean().required().default(false).label('Não mostrar a coluna desconto no financeiro'),
    siterecibo: yup.boolean().required().nullable().default(false).label('Declaração quitação débito - Simples'),
    siterecibo_detalhado: yup
        .boolean()
        .required()
        .nullable()
        .default(false)
        .label('Declaração quitação débito - Detalhado'),
    titulo_pagina: yup.string().required().label('Título da página'),
    titulo_site: yup.string().required().label('Título do site'),
    vindi_apikey: yup.string().notRequired().nullable().default(undefined).label('Chave da Api do Vindi'),
    grafico_boletim_aluno: yup
        .boolean()
        .required()
        .default(false)
        .label('Apresentar gráfico de analise de notas no boletim do aluno'),
});
exports.schemaYupConfiguracoes = exports.yupConfiguracoes.shape({});
